import React, { FunctionComponent } from 'react'
import Media from 'react-media';
import { BREAKPOINT } from '../constants';

type Breakpoints = {
  extraSmall: string,
  small: string,
  medium: string,
  up_to_large: string,
  large: string,
  extraLarge: string,
  small_medium: string,
  small_large: string,
  medium_large: string,
  large_extraLarge: string,
}

type BreakpointProps = {
  name?: string,
  children?: any,
};

export const breakpoints: Breakpoints = {
  extraSmall: `(max-width: ${BREAKPOINT.EXTRA_SMALL}px)`,
  small: `(min-width: ${BREAKPOINT.SMALL}px)`,
  medium: `(min-width: ${BREAKPOINT.MEDIUM}px)`,
  large: `(min-width: ${BREAKPOINT.LARGE}px)`,
  up_to_large: `(max-width: ${BREAKPOINT.LARGE}px)`,
  extraLarge: `(min-width: ${BREAKPOINT.EXTRA_LARGE}px)`,
  small_medium: `(min-width: ${BREAKPOINT.SMALL}px) and (max-width: ${BREAKPOINT.MEDIUM - 1}px)`,
  small_large: `(min-width: ${BREAKPOINT.SMALL}px) and (max-width: ${BREAKPOINT.LARGE - 1}px)`,
  medium_large: `(min-width: ${BREAKPOINT.MEDIUM}px) and (max-width: ${BREAKPOINT.LARGE - 1}px)`,
  large_extraLarge: `(min-width: ${BREAKPOINT.LARGE}px) and (max-width: ${BREAKPOINT.EXTRA_LARGE - 1}px)`,
};

const Breakpoint: FunctionComponent<BreakpointProps> = ({ name, children, ...otherProps }) => {
  const breakpointName = name as keyof typeof breakpoints;
  const breakpoint = breakpoints[breakpointName] || breakpoints.extraSmall;
  return (
    <Media {...otherProps} query={breakpoint}>
      {children}
    </Media>
  );
};

export const BreakpointXSM: FunctionComponent<BreakpointProps> = ({ children }) => <Breakpoint name="extraSmall">{children}</Breakpoint>
export const BreakpointSML: FunctionComponent<BreakpointProps> = ({ children }) => <Breakpoint name="small">{children}</Breakpoint>
export const BreakpointMED: FunctionComponent<BreakpointProps> = ({ children }) => <Breakpoint name="medium">{children}</Breakpoint>
export const BreakpointUpToLRG: FunctionComponent<BreakpointProps> = ({ children }) => <Breakpoint name="up_to_large">{children}</Breakpoint>
export const BreakpointLRG: FunctionComponent<BreakpointProps> = ({ children }) => <Breakpoint name="large">{children}</Breakpoint>
export const BreakpointXLG: FunctionComponent<BreakpointProps> = ({ children }) => <Breakpoint name="extraLarge">{children}</Breakpoint>
export const BreakpointSMLMED: FunctionComponent<BreakpointProps> = ({ children }) => <Breakpoint name="small_medium">{children}</Breakpoint>
export const BreakpointSMLLRG: FunctionComponent<BreakpointProps> = ({ children }) => <Breakpoint name="small_large">{children}</Breakpoint>
export const BreakpointMEDLRG: FunctionComponent<BreakpointProps> = ({ children }) => <Breakpoint name="medium_large">{children}</Breakpoint>
export const BreakpointLRGXLG: FunctionComponent<BreakpointProps> = ({ children }) => <Breakpoint name="large_extraLarge">{children}</Breakpoint>

export default Breakpoint;
